import { preferStableObjectReferenceArrayNullable, preferStableObjectReferenceNullable, } from "@plansoft-configuration-renderer/utils";
export function diffConfigurationObject(previous, next) {
    if (previous == null || next == null) {
        return next;
    }
    return Object.assign(Object.assign({}, next), { 
        // preserve variables
        variables: preferStableObjectReferenceNullable(previous.variables, next.variables), 
        // preserve attributes
        attributes: preferStableObjectReferenceArrayNullable(previous.attributes, next.attributes), 
        //  preserve attributeGroups
        attributeGroups: preferStableObjectReferenceArrayNullable(previous.attributeGroups, next.attributeGroups) });
}
//# sourceMappingURL=diffConfigurationObject.js.map